export const SELECTED_ACCOUNT_KEY = 'adv-account-selection-account-id';
export const SELECTED_SEEK_ACCOUNT_KEY = 'adv-account-selection-seek-id';
